import React from 'react';

import { Info, FindUs, Footer, Gallery, Header, Intro, Technicians, Services} from './container';
import { Navbar } from './components';
import './App.css';

const App = () => (
  <div>
    <Navbar />
    <Header />
    <Gallery />
    <FindUs />
    <Info />
    <Intro />
    <Services />
    <Technicians />
    <Footer />
  </div>
);

export default App;
